import PropTypes from 'prop-types';
import { ConfigProvider, theme } from 'antd';

// Ant Design theme configuration
const antTheme = {
  token: {
    // Primary colors
    colorPrimary: '#1976d2',
    colorSuccess: '#4caf50',
    colorWarning: '#ff9800',
    colorError: '#f44336',
    colorInfo: '#03a9f4',

    // Border radius
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    // Font
    fontFamily: "'Inter', 'Public Sans', 'Roboto', sans-serif",
    fontSize: 14,

    // Colors
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorBorder: '#e0e0e0',
    colorText: '#262626',
    colorTextSecondary: '#8c8c8c',

    // Sizing
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Select: {
      borderRadius: 8,
      controlHeight: 40,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Table: {
      borderRadius: 8,
    },
    Modal: {
      borderRadiusLG: 12,
    },
    Menu: {
      itemBorderRadius: 8,
    },
  },
};

// ==============================|| THEME CUSTOMIZATION - ANT DESIGN ||============================== //

export default function ThemeCustomization({ children }) {
  return (
    <ConfigProvider
      theme={{
        ...antTheme,
        algorithm: theme.defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  );
}

ThemeCustomization.propTypes = {
  children: PropTypes.node
};
